import React from 'react';
import SvgIcon from './SvgIcon';
import styles from './LogoIcon.module.css';

/**
 * @param {FF.SvgIcon} props
 */
function LogoIcon(props) {
  return (
    <SvgIcon
      viewBox="0 0 237.39 90.51"
      {...props}
      className={`${styles.logo} ${props.className || ''}`}
    >
      <title>Farmers Fridge</title>
      <path d="M16.44 32.95h12.58v-8.62H16.44v-7.49h18.35V5.7H0v39.41h16.44V32.95zM37.35 79.68V69.45H16.44v-7.37h20.91V51.1H0v39.41h15.24V79.68h22.11zM209.28 9.6v18.32L223 31.8V34l-13.51-1.25v9.62c9.71 4.24 20 4.14 27.95-1.42V23.49l-14.34-4.81v-1.83h13l1.29-8.51c-8.76-4.29-17.94-4.96-28.11 1.26zM198.49 8.47h3.05l-.57 5.44 3.51.28 4.53-7.82V0h-10.52v8.47z" />
      <path d="M183.6 45v-9.47h5l5.49 9.47h12.35v-2.77L193.6 29.81c10.76-5.88 7.05-23.75-8-24l-13.29-.14V45zM237.39 79.98h-21.17v-6.07h17.86v-7.77h-17.86v-5.42h21.17V51.1h-37.61v39.41h37.61V79.98zM141.55 44.97h26.47v-10.9h-13.98v-5.93h11.52v-7.77h-11.52v-4.95h13.98V5.67h-26.47v39.3zM195.42 69.1h-13.95l-2 7.72H172V64.94h20.32V51.1h-19.43c-9.93 0-17 5.11-19.85 11.43v16.4c2.85 6.47 9.92 11.58 19.85 11.58h4.47l3.64-5.57 4.22 5.57h10.23zM97.03 44.97h11.62l.9-13.69 9.39 12.15 7.32-12.53.7 14.07h11.05l-2.93-39.3h-11.56L118.28 18l-3.91-12.33h-15.7l-1.64 39.3zM74.62 45V34.79h4.16L82.48 45H94.1v-4.1L84.5 28c12.64-3.77 11-22.09-4.73-22.22l-16.06-.11V45zM129.86 51.1h-17.45v39.41h17.45c9.93 0 16.25-5.11 19-11.58V62.68c-2.75-6.47-9.07-11.58-19-11.58zM88.25 51.1h18.8v39.41h-18.8zM27.82 44.97h15.16v-7.64h7.39v7.64l10.26.14V34.02L52.16 5.39H42.1L27.82 44.97zM74.75 76.36c10.57-6.06 8.1-25.26-7.61-25.26H41.8v39.41h15V78.43H62l6.32 12.08h16.87v-4.66z" />
    </SvgIcon>
  );
}

export default LogoIcon;
